module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CUbEAj/tc-custom/9780715335369.jpg?1704286951528",
      "alt": "This image is the cover for the book Beader's Bible"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beader's Bible\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Beading techniques and over thirty beautiful projects for every experience level!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This is an indispensable guide to beads and beading techniques, presenting essential beading know-how together with a wide range of inspirational projects, tips and ideas."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Each chapter focuses on a different beading technique, guiding you through the basic skills, tools and materials, before tackling more advanced techniques and projects. "), _c('i', [_vm._v("The Beader’s Bible")]), _vm._v(" features over thirty “Bead Something Now” projects, ranging from bags and jewelry to stylish scarves and accessories—perfect excuses for trying out your new skills!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Easy-to-follow step-by-step instructions, clear diagrams, and stunning photography combine to create a must-have resource for beaders of all abilities.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dorothy Wood\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    D & C\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0